import { createContext, useContext, useEffect, useState } from "react";
import { STRINGS } from "@/lib/i18n";

const LanguageContext = createContext(null);
const KEY = "mgfx_lang";

function detectInitialLang() {
  const stored = localStorage.getItem(KEY);
  if (stored) return stored;
  try {
    const langs = navigator.languages || [navigator.language || ""];
    if (langs.some((l) => (l || "").toLowerCase().startsWith("ar"))) return "ar";
  } catch (e) {}
  return "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectInitialLang);
  const dir = lang === "ar" ? "rtl" : "ltr";

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
  }, [lang, dir]);

  const setLang = (l) => {
    localStorage.setItem(KEY, l);
    setLangState(l);
  };

  const L = STRINGS[lang] || STRINGS.en;

  return (
    <LanguageContext.Provider value={{ lang, setLang, dir, L, isAr: lang === "ar" }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
